<template>
    <div class="row">
        <div class="col-xs-12 col-sm-8 offset-sm-2">            
            <div class="card">
                <div class="card-body text-center">                    
                    <h3 class="card-title" v-if="!error && !isClassicPortalRedirect">
                        <span class="fa fa-spinner fa-spin text-success mr-1"></span>
                        Getting your Survey Details...                        
                    </h3>

                    <!-- Handle redirects from the classic portal -->
                    <div v-if="isClassicPortalRedirect">
                        <h3 class="card-title" >
                            <span class="fa fa-info-circle text-success mr-1"></span>
                            We're currently unable to process your payment online
                        </h3>
                        <p style="font-size: 1.3em;">
                            Please call our friendly team on 01904 468 881, who will be happy to help.
                        </p>
                    </div>
                    <!-- /Handle redirects from the classic portal -->
                    
                    <div v-if="error">
                         <h3 class="card-title">
                            <span class="fa fa-exclamation-triangle text-warning mr-1"></span>
                            Sorry, we ran into an error
                        </h3>
                        <p style="font-size: 1.3em;">
                            But there's nothing to worry about. Please call our friendly team on 01904 468 881, who will be happy to help
                        </p>
                    </div>
                   
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        props: {
            jobToken: String
        },
        data() {
            return {
                jobDetails: null,
                isClassicPortalRedirect: false,
                error: null
            }
        },
        async mounted() {
            // Handle legacy token redirect from old portal
            if (this.jobToken == 'fromclassicportal') {
                this.isClassicPortalRedirect = true
                return
            }

            try {
                let jobDetailsUrl = `/.netlify/functions/verify-job-info`
                let result = await axios.post(jobDetailsUrl, {
                    job_token: this.jobToken
                })                

                //this.jobDetails = result.data
                this.$router.push({ 
                    name: 'payment-details',
                    params: {
                        jobDetails: result.data,
                        jobToken: this.jobToken
                    }
                })
            } catch (error) {
                this.error = error
                console.error(error.message)
            }
        }
    }
</script>

